import React from 'react'
import Pagetitle from './../components/pagetitle/Pagetitle'
import Servicedetail from '../components/servicedetail/Servicedetail'
import appdevelopment from './../Images/MobileApp-04137bde87a05ba22ef3ab604a504969.png'
export default function Mobileappdevelopment() {
  const servicetechnologies = ['React Native' ,
'Expo' ,
'JavaScript' ,
'Android Studio',
'Redux',
'Typescript',
'Firebase',
'Nodejs',
'MongoDB']
  return (
    <div>
      <Pagetitle pagename="Mobile App Development" parentpage="Home" />
      <Servicedetail serviceimg={appdevelopment} technologies={servicetechnologies}servicesabout="Our Mobile App Developers are adopting modern, user based methodologies, and technologies for building both IOS AND Android mobile apps. ​" />
    </div>
  )
}
